export default __webpack_public_path__ + "static/media/arrow.cdcab76f.svg";